import React, { Fragment, useEffect, useState } from 'react';
import { Container, Row, Form, Col, Table, Card } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { FaMagnifyingGlass } from "react-icons/fa6";
import { formato_monto } from '../../../common/Formatos'

const DestinatariosPago = ({ }) => {
    
    const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
    const { cfg_form_implicado } = data_datos_generales
    const data_datos_implicado = useSelector((state) => state.implicadoReducer)
    const { datosPantalla} = data_datos_implicado
    const [destinatarioIndex, setDestinatarioIndex] = useState(null)
    const [destinatariosPago, setDestinatariosPago] = useState([])
    const [destinatarioPago, setDestinatarioPago] = useState({})
    
    useEffect(() => {
        if (datosPantalla && datosPantalla.length !== 'undefined') {
            const destinatarios = datosPantalla.datosPantalla[0]['destinatariosPago'] || [];
            setDestinatariosPago(destinatarios);
        } else {
            setDestinatariosPago([]);
        }
    }, [datosPantalla])

    const handleVerDestinatarios = (destinatario, index) => {
        setDestinatarioIndex(index)
        setDestinatarioPago(destinatario)
    }

    return (
        <Fragment>
            <Card className='mt-1 '>
                <Container>
                    <Row className="mt-4">
                        <Col>
                        <Table striped hover className="table destinatarios-table">
                            <thead >
                            <tr>
                                <th>Tipo Destinatario</th>
                                <th>Nit</th>
                                <th>Nombre</th>
                                <th>Email</th>
                                <th>Monto</th>                        
                                <th>Ver Detalle</th>
                            </tr>
                            </thead>

                            <tbody>
                            {destinatariosPago.length === 0 ? (
                                <tr>
                                <td colSpan="6" className="text-center">
                                    Sin destinatarios
                                </td>
                                </tr>
                            ) : (
                                destinatariosPago.map((row, index) => (
                                <tr key={index}>
                                    <td>{row.glosaTipoDestinatario}</td>
                                    <td>{row.rutDestinatario}</td>
                                    <td>{row.nombreDestinatario}</td>
                                    <td>{row.emailDestinatario}</td>
                                    <td>{formato_monto(row.montoPago)}</td>

                                    <td className="text-center">                              
                                    <FaMagnifyingGlass className='icon'
                                        size={20}
                                        color='gray'
                                        title="Ver Destinatario"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => handleVerDestinatarios(row, index)}
                                    />
                                    </td>
                                </tr>
                                ))
                            )}
                            </tbody>
                        </Table>
                        </Col>
                    </Row>
                    {destinatarioIndex !== null && (

                        <Card>
                            <Card.Header as='h6' className='text-center' style={{ backgroundColor: '#4F517A', color: 'white' }} onClick={() => setDestinatarioIndex(null)}>
                                Destinatario de Pago
                            </Card.Header>
                            <Card.Body>
                                <Container> 
                                    <Row>
                                        <Col md='3'>
                                            <Form.Label className="label">
                                                Destinatario
                                            </Form.Label>
                                            <br />
                                            <Form.Text className='mb-3'>
                                                {destinatarioPago.glosaTipoDestinatario}
                                            </Form.Text>
                                        </Col>
                                        <Col md='3'>
                                            <Form.Label className="label">
                                                Nit
                                            </Form.Label>
                                            <br />
                                            <Form.Text className='mb-3'>
                                                {destinatarioPago.rutDestinatario}
                                            </Form.Text>
                                        </Col>
                                        <Col md='3'>
                                            <Form.Label className="label">
                                                Nombre
                                            </Form.Label>
                                            <br />
                                            <Form.Text className='mb-3'>
                                                {destinatarioPago.nombreDestinatario}
                                            </Form.Text>
                                        </Col>
                                        <Col md='3'>
                                            <Form.Label className="label">
                                                Email
                                            </Form.Label>
                                            <br />
                                            <Form.Text className='mb-3'>
                                                {destinatarioPago.emailDestinatario}
                                            </Form.Text>
                                        </Col>
                                    </Row>
                                </Container>
                                <Container style={{ marginTop: '15px' }}>
                                    <Row>
                                        <Col>
                                            <Form.Label className="label">
                                                Medio de Pago
                                            </Form.Label>
                                            <br />
                                            <Form.Text className='mb-3'>
                                                {destinatarioPago.glosaMedioPago}
                                            </Form.Text>
                                        </Col>
                                        <Col>
                                            <Form.Label className="label">
                                                Tipo de Cuenta
                                            </Form.Label>
                                            <br />
                                            <Form.Text className='mb-3'>
                                                {destinatarioPago.glosaTipoCuentaFinanciera}
                                            </Form.Text>
                                        </Col>
                                        <Col>
                                            <Form.Label className="label">
                                                Insitución Financiera
                                            </Form.Label>
                                            <br />
                                            <Form.Text className='mb-3'>
                                                {destinatarioPago.glosaInstFinanciera}
                                            </Form.Text>
                                        </Col>
                                        <Col>
                                            <Form.Label className="label">
                                                Nro de Cuenta
                                            </Form.Label>
                                            <br />
                                            <Form.Text className='mb-3'>
                                                {destinatarioPago.numeroCuenta}
                                            </Form.Text>
                                        </Col>
                                        <Col>
                                            <Form.Label className="label">
                                            Monto de Pago
                                            </Form.Label>
                                            <br />
                                            <Form.Text className='mb-3'>
                                                {destinatarioPago.montoPago ? formato_monto(destinatarioPago.montoPago) : ''    }
                                            </Form.Text>
                                        </Col>
                                    </Row>
                                </Container>    
                            </Card.Body>
                        </Card>
                    )}                 
                </Container>
            </Card>
        <style type='text/css'>
            {`        
                .label {
                    font-weight: bold;
                    font-size: 14px;
                }
                .is_required:after {
                    content: "*";
                    margin-left: 2px;
                    color: #000;
                    font-weight: 500;
                    font-size: 12pt;
                }            
                .destinatarios-table thead th {
                    background-color: #4F517A;
                    color: white;
                }
            `}
        </style>
        </Fragment>
    )
}
export default DestinatariosPago;